
import React from 'react';
import { EcomPaymentSettings } from '@/lib/supabase/payments/types';
import { CashOnDeliveryMethod } from './components/CashOnDeliveryMethod';
import { StripePaymentMethod } from './components/StripePaymentMethod';
import { PayPalPaymentMethod } from './components/PayPalPaymentMethod';

interface PaymentMethodsListProps {
  paymentSettings: EcomPaymentSettings | null;
  onTogglePaymentMethod: (method: 'cod' | 'stripe' | 'paypal', enabled: boolean) => Promise<void>;
  isSaving: boolean;
  shopId: string;
}

export const PaymentMethodsList: React.FC<PaymentMethodsListProps> = ({
  paymentSettings,
  onTogglePaymentMethod,
  isSaving,
  shopId
}) => {
  if (!paymentSettings) {
    return <div>Aucun paramètre de paiement trouvé</div>;
  }

  return (
    <div className="space-y-4">
      {/* Méthode de paiement à la livraison (COD) */}
      <CashOnDeliveryMethod 
        enabled={paymentSettings.cod_enabled}
        onToggle={(checked) => onTogglePaymentMethod('cod', checked)}
        disabled={isSaving}
      />

      {/* Stripe */}
      <StripePaymentMethod 
        enabled={paymentSettings.stripe_enabled}
        onToggle={(checked) => onTogglePaymentMethod('stripe', checked)}
        disabled={isSaving}
        shopId={shopId}
      />

      {/* PayPal */}
      <PayPalPaymentMethod
        enabled={paymentSettings.paypal_enabled}
        onToggle={(checked) => onTogglePaymentMethod('paypal', checked)}
        disabled={isSaving}
        shopId={shopId}
      />
    </div>
  );
};
